import React from "react";
import moment from "moment";
import { Modal } from "seed/helpers";
import NoteFormCreate from "components/presentation/history/notes/NoteFormCreate";
import NoteFormEdit from "components/presentation/history/notes/NoteFormEdit";
import PaginationFooter from "components/util/helpers/PaginationFooter";
import { bodyContentMapper } from "components/studio/board/nodes/Node.lib";
import { renderHTML } from "components/util/render_util";
import l from "components/util/l";
import "styles/css/presentation/Notes.css";

const FlowNotesView = ({
  flow,
  selectedNote = {},
  pageNum,
  totalPages,
  flowNotes = [],
  createModal,
  editModal,
  setPageNum,
  setCreateModal,
  setEditModal,
  refreshNotes,
  onClickSelectNote,
  onClickDelete,
}) => (
  <div>
    <div className="w-100 px-3 px-sm-4 h-100">

      <h2 className="pt-2 pb-3">{l("Notas%PA041")}</h2>

      <div className="row">
        <div className="col-12">

          {
            flowNotes.map(flowNote =>
              <div
                key={`flowNote-${flowNote.id}`}
                class="chat-note-item d-flex flex-column justify-content-between pr-2 pl-1 w-100 mb-2 rounded"
              >
                <div className="d-flex align-items-center w-100 justify-content-between">
                  <div className="d-flex align-items-start mx-3 pb-1 w-100 text-truncate">
                    <i className="chat-note-item-icon fa fa-sticky-note mr-3" />
                    <div>
                      <h5 className=" mt-1 mb-0">
                        {flowNote.title ?? l("Nota%PA042")}
                      </h5>

                      <span>
                        {flowNote.description}
                      </span>
                      <small className="d-flex text-wrap mr-2 text-muted">
                        {flowNote.user.firstName} {flowNote.user.lastName}
                        <span className="text-muted"> - </span>
                        {moment(flowNote.createdAt).format("DD.MMM / HH:mm")}
                      </small>
                    </div>
                  </div>

                  <button
                    className="chat-note-options btn btn-sm btn-lighter-white text-center px-3"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i className="fas fa-ellipsis-vertical" />
                  </button>

                  <div class="dropdown-menu dropdown-menu-right mt-n1" aria-labelledby="chat-note-options">
                    <button
                      className="dropdown-item"
                      onClick={() => {
                        setEditModal({
                          show: true,
                          noteId: flowNote.id
                        });
                      }}
                    >
                      <i className="fas fa-edit dropdown-item-icon mr-2" /> {l("Editar%GA002")}
                    </button>
                    <a href="#" class="dropdown-item" onClick={() => onClickDelete(flowNote.id)}>
                      <i className="fas fa-trash-alt dropdown-item-icon mr-2" /> {l("Eliminar%GA001")}
                    </a>
                  </div>

                </div>

                {
                  flowNote?.message &&
                  <div class="card mx-3 my-2">
                    <div class="card-body">
                      <div className="chat-note-item-message-content mb-2">
                        {
                          function () {

                            const action = flowNote.message?.action;
                            const content = flowNote.message?.content;

                            const text = content.text;

                            return renderHTML(
                              action?.node && action.node.action?.type == "TRIGGER" && !action.is_form
                                ? bodyContentMapper(action.node.action.ui_settings?.node, action.node.input_values,
                                  "execution_message", action.node.action.ui_settings.form)
                                : (text)
                            )

                          }()
                        }
                      </div>

                      {
                        selectedNote?.id == flowNote.id &&
                        <div className="chat-note-item-active-button btn btn-sm btn-lighter mb-1 w-100">
                          {l("Chat activo%PA043")}
                        </div>
                      }

                      {
                        selectedNote?.id != flowNote.id &&
                        <button
                          className="chat-note-item-button btn btn-sm btn-lighter mb-1 mr-2 w-100"
                          onClick={() => onClickSelectNote(flowNote)}
                        >
                          {l("Ver chat%PA044")}
                        </button>
                      }


                    </div>
                  </div>
                }

              </div>
            )
          }

        </div>
      </div>

      {flowNotes.length > 0 &&
        <button
          className="btn btn-sm btn-link mt-2 w-100 mb-2"
          onClick={() => setCreateModal({ show: true })}>
          <i className="fas fa-add mr-2"></i>
          {l("Crear nota%PA035")}
        </button>
      }



      {totalPages > 1 &&
        <PaginationFooter
          pageNum={pageNum}
          totalPages={totalPages}
          onClickPage={setPageNum}
        />
      }

      {
        createModal &&
        <Modal
          width="800"
          height="800"
          flow={flow}
          refreshNotes={refreshNotes}
          component={NoteFormCreate}
          onClose={() => setCreateModal(null)}
        />
      }

      {
        editModal &&
        <Modal
          width="800"
          height="800"
          flow={flow}
          noteId={editModal.noteId}
          refreshNotes={refreshNotes}
          component={NoteFormEdit}
          onClose={() => setEditModal(null)}
        />
      }

      {flowNotes.length == 0 &&
        <div id="no-data-content" className="text-center my-10 h-100">
          <i className="fas fa-note-sticky mb-4 fa-3x"></i><br />
          <h3 className="text-muted d-inline-block">
            <div className="mb-0">{l("No tienes notas registradas%PA045")}</div>
            <small>{l("Guarda notas de mensajes importantes o recordatorios%PA046")}</small>
          </h3>
          <div>
            <button
              className="btn btn-primary mt-3 px-4"
              onClick={() => setCreateModal({ show: true })}
            >
              <i className="fas fa-add mr-2"></i> {l("Crear nota%PA035")}
            </button>
          </div>
        </div>}

    </div>
  </div>
)

export default FlowNotesView;